import React, { useCallback, useEffect } from 'react';
import useLocalStorage from 'hooks/useLocalStorage';
import { trackOpenAdjacentDialog, trackCloseAdjacentDialog } from 'metrics/user-analytics/seats';
import AdjacentSeatDialog from './AdjacentSeatDialog';

/**
 * Component that shows the adjacent seat onboarding modal only the first time.
 * Uses localStorage to persist if the user has already seen it.
 */
const AdjacentSeatOnboarding = () => {
  const [hideAdjacentDialog, setHideAdjacentDialog] = useLocalStorage('hideAdjacentDialog', false);
  const openModal = !hideAdjacentDialog;

  const handleClose = useCallback(() => {
    setHideAdjacentDialog(true);
    trackCloseAdjacentDialog();
  }, [setHideAdjacentDialog]);

  useEffect(() => {
    if (openModal) {
      trackOpenAdjacentDialog();
    }
  }, [openModal]);

  return <AdjacentSeatDialog show={openModal} onClose={handleClose} />;
};

export default AdjacentSeatOnboarding;
